{
  "name": "auth-frontend",
  "version": "1.407.264",
  "engines": {
    "node": ">=24.5.0"
  },
  "scripts": {
    "build": "ng build",
    "csp:inject": "node scripts/inject-csp-nonce.js",
    "csp:verify": "node scripts/verify-csp-nonce.js",
    "jsonServer": "json-server --watch json-server/db/db.json --routes json-server/routes/routes.json --middlewares json-server/middlewares/middleware.js",
    "killJsonServer": "kill -9 $(lsof -t -i:3000)",
    "killLocalDev": "lsof -ti tcp:4000 | xargs kill -9",
    "killPorts": "npm-run-all killJsonServer killLocalDev",
    "lint": "ng lint",
    "ng": "ng",
    "postinstall": "node scripts/apply-patches.js",
    "prodBuild": "ng build --aot --configuration production --output-hashing=all && npm run csp:inject -- dist/prod/auth-frontend && npm run csp:verify -- dist/prod/auth-frontend",
    "proxyServe": "ng serve --host 0.0.0.0 --port 4000 --proxy-config proxy.conf.json",
    "sbxBuild": "ng build --configuration=sbx && npm run csp:inject -- dist/sbx/auth-frontend && npm run csp:verify -- dist/sbx/auth-frontend",
    "start": "npm-run-all --parallel jsonServer proxyServe",
    "test": "ng test",
    "test:csp": "node scripts/inject-csp-nonce.spec.js",
    "test:all": "npm run test:csp && npm run test",
    "test-no-watch": "ng test --watch=false",
    "test-with-coverage": "ng test --watch=false --coverage",
    "uatBuild": "ng build --configuration=uat && npm run csp:inject -- dist/uat/auth-frontend && npm run csp:verify -- dist/uat/auth-frontend"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.25",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.25",
    "@angular/compiler": "21.2.25",
    "@angular/core": "21.2.25",
    "@angular/forms": "21.2.25",
    "@angular/material": "21.2.14",
    "@angular/platform-browser": "21.2.25",
    "@angular/platform-browser-dynamic": "21.2.25",
    "@angular/platform-server": "21.2.25",
    "@angular/router": "21.2.25",
    "@datadog/browser-logs": "6.33.0",
    "@datadog/browser-rum": "6.33.0",
    "@fullstory/browser": "2.0.8",
    "@marlettestandards/frontend-design": "^1.4.0",
    "@ngrx/effects": "21.1.0",
    "@ngrx/router-store": "21.1.0",
    "@ngrx/store": "21.1.0",
    "@ngrx/store-devtools": "21.1.0",
    "@segment/analytics-consent-wrapper-onetrust": "1.1.3",
    "@segment/analytics-next": "1.84.0",
    "aws-amplify": "^6.17.0",
    "chart.js": "3.7.1",
    "chartjs-plugin-annotation": "1.4.0",
    "core-js": "3.49.0",
    "js-cookie": "3.0.8",
    "ng-recaptcha-2": "21.0.1",
    "ngx-cookie-service": "^21.3.1",
    "ngx-mask": "^21.0.1",
    "ngx-webstorage": "^21.0.1",
    "rxjs": "7.8.2",
    "tslib": "2.8.1",
    "uuid": "14.0.0",
    "zone.js": "0.16.1"
  },
  "devDependencies": {
    "@angular-devkit/core": "21.2.28",
    "@angular/build": "^21.2.28",
    "@angular/cli": "21.2.28",
    "@angular/compiler-cli": "21.2.25",
    "@angular/language-service": "21.2.25",
    "@tailwindcss/postcss": "4.3.3",
    "@types/chart.js": "2.9.41",
    "@types/node": "22.19.17",
    "@vitest/coverage-v8": "4.1.12",
    "jsdom": "28.1.0",
    "npm-run-all2": "8.0.4",
    "postcss": "8.5.23",
    "tailwindcss": "4.3.3",
    "ts-node": "10.9.2",
    "typescript": "5.9.3",
    "vitest": "4.1.12"
  },
  "overrides": {
    "@marlettestandards/frontend-design": {
      "tailwindcss": "$tailwindcss"
    },
    "@babel/core": "7.29.7",
    "cookie": "^0.7.2",
    "js-cookie": "$js-cookie",
    "uuid": "$uuid",
    "vite": "7.3.7",
    "undici": "7.30.1",
    "@modelcontextprotocol/sdk": "1.32.1",
    "@hono/node-server": "2.1.3",
    "hono": "^4.13.5",
    "esbuild": "0.28.1",
    "ip-address": "10.7.4",
    "brace-expansion": "5.0.12",
    "nanoid": "3.3.18",
    "pacote": "21.5.1",
    "browserslist": "4.28.7",
    "fast-uri": "3.1.9",
    "qs": "6.16.1",
    "postcss-selector-parser": "6.1.4"
  }
}
